export const ELEMENT_SELECTOR = '[data-component="navigation"]'
